<div class="viewport">
  <div class="font-bigtext loginbar"
    [ngClass]="{'layout-colorful': (layoutClass == 'layout-colorful'),'layout-dark': (layoutClass == 'layout-dark'),'layout-light': (layoutClass == 'layout-light')}">
    <table cellpadding="0" cellspacing="0" border="1" style="height: 100%;width:100%">
      <tr>
        <td style="height: 100%; vertical-align: middle;">

          <div class="ContentWrapper">
            <div class="InputWrapper">
              <input a11y_Input (input)="changeEMail($event.target.value)" class="text full-width" id="emailAddress"
                type="email" (blur)="setWebView()" placeholder="{{placeholderEMail}}" />
              <input a11y_Input (input)="changePassword($event.target.value)" class="text full-width" id="passwort"
                type="password" (blur)="setWebView()" placeholder="{{placeholderPassword}}" />
              <div #messageBox class="MessageWrapper" [innerHTML]="loginMessage"></div>
            </div>
            <!--
        <div class="BoxWrapper">
          <div>
            <a [routerLink]="['/dist']" class="ref" name="toForgotPassword" langkey="phLogin_ForgotPassword"></a>
          </div>
        </div>
  -->
            <!--<div class="BoxWrapper">
    <div>
      <a (click)="sendPasswordResetEmail()" class="ref" name="toForgotPassword" langkey="phLogin_ForgotPassword"></a>
    </div>
  </div>-->
            <div class="ButtonWrapper">
              <button a11y_Button (click)="StartSync()" class="button" name="login">StartSync</button>
            </div>
            <div class="ButtonWrapper">
              <button a11y_Button (click)="Login()" class="button" name="login">phLogin_LogIn</button>
            </div>
            <div class="ButtonWrapper">
              <button a11y_Button (click)="GetDeviceToken()" class="button">GetDeviceToken</button>
            </div>
            <div class="ButtonWrapper">
              <button a11y_Button (click)="SignInNobody()" class="button">Login_Nobody</button>
            </div>
            <div class="ButtonWrapper">
              <button a11y_Button (click)="SignInAnonymous()" class="button">Login_Anonymous</button>
            </div>
            <div class="ButtonWrapper">
              <button a11y_Button (click)="TestAuthFunction()" class="button">Login_TestAuthFunction</button>
            </div>

            <div class="ButtonWrapper">
              <button a11y_Button (click)="TestDownload()" class="button">phLogin_TestDownload</button>
            </div>
            <div class="ButtonWrapper">
              <button a11y_Button (click)="TestChangedata()" class="button">phLogin_Changedata</button>
            </div>
            <div class="ButtonWrapper">
              <button a11y_Button (click)="TestRefresh()" class="button">phLogin_Refresh</button>
            </div>


            <!--<div class="RefWrapper">
    <a [routerLink]="['/dist/register']" class="ref" [ngClass]="{light: (this.layoutClass == 'layout-light')}" name="toLogin" langkey="phLogin_NotAMember"></a>
  </div>-->
            <a routerLink="/" mat-icon-button>
              <span>Back To Home</span>
            </a>
            <div style="background: white;" [innerHTML]="qrcodesvg"></div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>